<script setup>
import { ref, watch, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Modal from './Modal.vue'

const route = useRoute()
const router = useRouter()
const showModal = ref(false)
const cause = ref('')

const handleClose = () => {
  showModal.value = false

  // Remove the redirect query parameters
  const query = { ...route.query }
  delete query.redirect
  delete query.cause
  router.replace({ query })
}

watch(
  () => route.query,
  (newQuery) => {
    if (newQuery.redirect && newQuery.cause) {
      cause.value = newQuery.cause
      showModal.value = true
    }
  },
  { immediate: true },
)

const redirectMessage = computed(() => {
  return {
    UNFINISHED_PROCESSING_LEAD: {
      title: 'Lead en cours de traitement',
      message:
        'Vous avez un lead en cours de traitement. Veuillez terminer le traitement de ce lead.',
    },
    UNTAGGED_CALL: {
      title: 'Appel non taggé',
      message: 'Vous avez un appel non taggé. Veuillez tagger ce lead.',
    },
    ONGOING_CALL: {
      title: 'Appel en cours',
      message: 'Vous avez un appel en cours. Veuillez terminer le traitement de ce lead.',
    },
  }[cause.value]
})
</script>

<template>
  <Modal v-if="showModal" :title="redirectMessage.title" size="sm" @close="handleClose">
    <div class="flex flex-col items-center p-2">
      <p class="text-center">{{ redirectMessage.message }}</p>
      <q-btn label="Continuer" color="accent" unelevated no-caps @click="handleClose" />
    </div>
  </Modal>
</template>
